$(function() {
    const swiperArchive = new Swiper('#swiper-archive', {
      autoHeight: true,
      allowTouchMove: false,
      slidesPerView: 1,
      spaceBetween: 10,
      effect: 'fade',
      fadeEffect: {
          crossFade: true,
      },
    });

    // Initial binding for first page items
    $('.archive-container').on('mouseenter', function() {
        const projectNumber = $(this).data('project');
        $('.archive-container').removeClass('active');
        $(this).addClass('active');
    
        if (projectNumber !== undefined) {
            swiperArchive.slideTo(projectNumber);
        }
    });

    // Infinite Scroll Implementation
    const paginationContainer = document.querySelector('.pagination');
    
    if (paginationContainer) {
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const nextUrl = paginationContainer.dataset.nextUrl;
                    if (nextUrl) {
                        loadNextPage(nextUrl);
                    }
                }
            });
        }, observerOptions);

        observer.observe(paginationContainer);

        let isLoading = false;

        function loadNextPage(url) {
            if (isLoading) return;
            isLoading = true;

            fetch(url)
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    
                    // Append new swiper slides
                    const currentSlideCount = swiperArchive.slides.length;
                    const newSlides = doc.querySelectorAll('.swiper-slide');
                    newSlides.forEach(slide => {
                        swiperArchive.appendSlide(slide);
                    });
                    swiperArchive.update();

                    // Append new archive items
                    const newItems = doc.querySelectorAll('.archive-container');
                    const listContainer = document.querySelector('.archive-list');
                    newItems.forEach(item => {
                        // Adjust project index for continuous swiping
                        let originalIndex = parseInt(item.getAttribute('data-project'));
                        if (!isNaN(originalIndex)) {
                            item.setAttribute('data-project', originalIndex + currentSlideCount);
                        }
                        
                        listContainer.appendChild(item);
                        // Re-bind hover event for new items
                         $(item).on('mouseenter', function() {
                            const projectNumber = $(this).data('project');
                            $('.archive-container').removeClass('active');
                            $(this).addClass('active');
                        
                            if (projectNumber !== undefined) {
                                swiperArchive.slideTo(projectNumber);
                            }
                        });
                    });
                    
                    // Re-trigger animation observers for new elements
                    if (typeof setAnimationWaypoints === 'function') {
                        setAnimationWaypoints();
                    }

                    // Update next URL
                    const newPagination = doc.querySelector('.pagination');
                    if (newPagination && newPagination.dataset.nextUrl) {
                        paginationContainer.dataset.nextUrl = newPagination.dataset.nextUrl;
                    } else {
                        paginationContainer.removeAttribute('data-next-url');
                        // Optional: Hide pagination if no more pages
                        paginationContainer.style.display = 'none';
                    }
                })
                .catch(err => console.error('Error loading next page:', err))
                .finally(() => {
                    isLoading = false;
                });
        }
    }
});


